Drupal.behaviors.infiniteScrollBehaviour = {
  attach: function (context, settings) {
    // Use context to filter the DOM to only the elements of interest,
    // and use once() to guarantee that our callback function processes
    // any given element one time at most, regardless of how many times
    // the behaviour itself is called (it is not sufficient in general
    // to assume an element will only ever appear in a single context).
    let [offset, limit] = [0, 4];
    let paginationCounter = 0;
    let intersectionPaginationOffset = 12;

    /* let content_wrapper = once(
      "infiniteScroll",
      ".infinite-scroll-recent-articles",
      context
    ); */

    /* Load intersection observer when loader element exists */
    let content_loader = once(
      "infiniteScrollRubricLoader",
      ".rubric-articles-loader",
      context
    );

    let index = 0;

    content_loader.forEach((loader) => {
      /* let wrapper = once(
        "infiniteScrollRubric",
        ".infinite-scroll-rubric-articles",
        context
      ); */
      let wrapper = context.querySelector(".infinite-scroll-rubric-articles");
      let term_id = wrapper.dataset.termId;

      initialContentLoading(wrapper, paginationCounter, index, term_id);

      let callback = (entries, observer) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            intersectionContentLoading(
              wrapper,
              intersectionPaginationOffset,
              limit,
              index,
              term_id
            );
            intersectionPaginationOffset += 4;
          }
        });
      };

      let options = {
        root: document,
        rootMargin: "500px 0px 500px 0px",
        threshold: 0,
      };

      let intersectionObserver = new IntersectionObserver(callback, options);
      setTimeout(() => {
        intersectionObserver.observe(loader);
      }, 500);
    });
    /* ***************************************************** */
  },
};

const intersectionContentLoading = (
  wrapper,
  intersectionPaginationOffset,
  limit,
  index,
  term_id
) => {
  /* ************** Insert content ******************** */

  let article_content_placeholder = "";

  (async () => {
    try {
      const response = await fetch(
        `/api/recent-rubric-nodes?offset=${intersectionPaginationOffset}&limit=${limit}&tid=${term_id}`
      );
      const jsonData = await response.json();
      let field_updated = "";

      for await (let element of jsonData) {
        if (element.data.length !== 0) {
          if (
            element.data.field_updated === undefined ||
            element.data.field_updated.length === 0
          ) {
            field_updated = "";
          } else {
            if (element.data.field_updated[0].value == 1) {
              field_updated =
                '<span class="text-danger pl-1">(Papildyta)</span>';
            } else if (element.data.field_updated[0].value == 2) {
              field_updated =
                '<span class="text-danger pl-1">(Atnaujinta)</span>';
            }
          }

          article_content_placeholder += `
                        <div class="col-md-6 article-card">
                          <article>
                            <div class="media-block">
                              <div class="media-wrapper">
                                <div class="media-image">
                                  <img class="img-fluid" src="${
                                    element.image_url ? element.image_url : ""
                                  }" alt="${
            element.image_name
              ? element.image_name
              : element.data.title[0].value
          }">
                                </div>
                                <a href="${
                                  element.data.path[0].alias !== null
                                    ? element.data.path[0].alias
                                    : `/node/${element.data.nid[0].value}`
                                }" title="${element.data.title[0].value}"></a>
                              </div>
                            </div>
                            <div class="article-card-info">
                              <div class="article-media-info">
                                ${
                                  element.data.field_premium_content[0].value ==
                                  1
                                    ? '<span><i class="fa-solid fa-euro-sign"></i></span>'
                                    : ""
                                }
                                ${
                                  element.data.field_related_galleries[0]
                                    ? '<span><i class="fa-solid fa-camera"></i></span>'
                                    : ""
                                }
                                ${
                                  element.data.field_video[0].value != 0
                                    ? '<span><i class="fa-solid fa-circle-play"></i></span>'
                                    : ""
                                }
                                ${
                                  element.data.field_komentarai[0] &&
                                  element.data.field_komentarai[0]
                                    .comment_count > 0
                                    ? `<a href="${
                                        element.data.path[0].alias !== null
                                          ? element.data.path[0].alias
                                          : `/node/${element.data.nid[0].value}`
                                      }"/komentarai" title="Visi komentarai">
                                        <span class="publishing-info-icon">
                                          <i class="fa-solid fa-comment"></i>
                                          ${
                                            element.data.field_komentarai[0]
                                              .comment_count
                                          }
                                        </span>
                                      </a>`
                                    : ""
                                }
                              </div>
                              <div class="article-primary-rubric">
                                ${
                                  element.rubric !== undefined
                                    ? element.rubric[0]
                                    : ""
                                }
                              </div>
                            </div>
                            <a href="${
                              element.data.path[0].alias !== null
                                ? element.data.path[0].alias
                                : `/node/${element.data.nid[0].value}`
                            }" title="${
            element.data.title[0].value ? element.data.title[0].value : ""
          }">
                              <h5>${
                                element.data.title[0].value
                                  ? element.data.title[0].value
                                  : `/node/${element.data.nid[0].value}`
                              }
                              ${field_updated}
                              </h5>
                              ${
                                element.data.field_papildoma_antrastes_inform[0]
                                  ? `<span class="title-postfix">${element.data.field_papildoma_antrastes_inform[0].value}</span>`
                                  : ""
                              }
                            </a>
                        </article>
                      </div>
                      `;
        }
      }

      let infinite_scroll_ad = mobileAdByHost(index);
      if (index < 2) {
        index = index + 1;
      } else {
        index = 0;
      }
      article_content_placeholder += infinite_scroll_ad;

      wrapper.insertAdjacentHTML("beforeend", article_content_placeholder);
    } catch (error) {
      console.log(`Failed to fetch data. ${error}`);
    }
  })();
  /* ******** Insert Content End ****** */
};

const initialContentLoading = (wrapper, paginationCounter, index, term_id) => {
  /* ************** Insert content ******************** */

  let article_content_placeholder = "";
  let loop_index = 0;

  (async () => {
    try {
      const response = await fetch(
        `/api/recent-rubric-nodes?offset=${paginationCounter}&limit=12&tid=${term_id}`
      );
      const jsonData = await response.json();
      let field_updated = "";

      for await (let element of jsonData) {
        if (element.data.length !== 0) {
          if (
            element.data.field_updated === undefined ||
            element.data.field_updated.length === 0
          ) {
            field_updated = "";
          } else {
            if (element.data.field_updated[0].value == 1) {
              field_updated =
                '<span class="text-danger pl-1">(Papildyta)</span>';
            } else if (element.data.field_updated[0].value == 2) {
              field_updated =
                '<span class="text-danger pl-1">(Atnaujinta)</span>';
            }
          }

          article_content_placeholder += `
                        <div class="col-md-6 article-card">
                          <article>
                            <div class="media-block">
                              <div class="media-wrapper">
                                <div class="media-image">
                                  <img class="img-fluid" src="${
                                    element.image_url ? element.image_url : ""
                                  }" alt="${
            element.image_name
              ? element.image_name
              : element.data.title[0].value
          }">
                                </div>
                                <a href="${
                                  element.data.path[0].alias !== null
                                    ? element.data.path[0].alias
                                    : `/node/${element.data.nid[0].value}`
                                }" title="${element.data.title[0].value}"></a>
                              </div>
                            </div>
                            <div class="article-card-info">
                              <div class="article-media-info">
                                ${
                                  element.data.field_premium_content[0].value ==
                                  1
                                    ? '<span><i class="fa-solid fa-euro-sign"></i></span>'
                                    : ""
                                }
                                ${
                                  element.data.field_related_galleries[0]
                                    ? '<span><i class="fa-solid fa-camera"></i></span>'
                                    : ""
                                }
                                ${
                                  element.data.field_video[0].value != 0
                                    ? '<span><i class="fa-solid fa-circle-play"></i></span>'
                                    : ""
                                }
                                ${
                                  element.data.field_komentarai[0] &&
                                  element.data.field_komentarai[0]
                                    .comment_count > 0
                                    ? `<a href="${
                                        element.data.path[0].alias !== null
                                          ? element.data.path[0].alias
                                          : `/node/${element.data.nid[0].value}`
                                      }"/komentarai" title="Visi komentarai">
                                        <span class="publishing-info-icon">
                                          <i class="fa-solid fa-comment"></i>
                                          ${
                                            element.data.field_komentarai[0]
                                              .comment_count
                                          }
                                        </span>
                                      </a>`
                                    : ""
                                }
                              </div>
                              <div class="article-primary-rubric">
                                ${
                                  element.rubric !== undefined
                                    ? element.rubric[0]
                                    : ""
                                }
                              </div>
                            </div>
                            <a href="${
                              element.data.path[0].alias !== null
                                ? element.data.path[0].alias
                                : `/node/${element.data.nid[0].value}`
                            }" title="${
            element.data.title[0].value ? element.data.title[0].value : ""
          }">
                              <h5>${
                                element.data.title[0].value
                                  ? element.data.title[0].value
                                  : `/node/${element.data.nid[0].value}`
                              }
                              ${field_updated}
                              </h5>
                              ${
                                element.data.field_papildoma_antrastes_inform[0]
                                  ? `<span class="title-postfix">${element.data.field_papildoma_antrastes_inform[0].value}</span>`
                                  : ""
                              }
                            </a>
                        </article>
                      </div>
                      `;
          if (loop_index == 3) {
            let infinite_scroll_ad = mobileAdByHost(index);
            if (index < 2) {
              index = index + 1;
            } else {
              index = 0;
            }
            article_content_placeholder += infinite_scroll_ad;
            loop_index = 0;
            paginationCounter += 4;
          } else {
            loop_index++;
          }
        }
      }

      /* let infinite_scroll_ad = mobileAdByHost(index);
      if (index < 2) {
        index = index + 1;
      } else {
        index = 0;
      }
      article_content_placeholder += infinite_scroll_ad; */

      wrapper.insertAdjacentHTML("beforeend", article_content_placeholder);
    } catch (error) {
      console.log(`Failed to fetch data. ${error}`);
    }
  })();
  /* ******** Insert Content End ****** */
};

const mobileAdByHost = (index) => {
  let hostname = window.location.hostname;
  if (hostname.startsWith("www.diena") || hostname.startsWith("diena")) {
    return '<div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=700284"></script></div>';
  } else if (hostname.startsWith("m.diena")) {
    if (index == 0) {
      return '<!-- Tag for diena.lt - VD M8 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=648475"></script></div>';
    } else if (index == 1) {
      return '<!-- Tag for diena.lt - VD M9 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847326"></script></div>';
    } else if (index == 2) {
      return '<!-- Tag for diena.lt - VD M10 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847327"></script></div>';
    }
  } else if (hostname.startsWith("klaipeda.diena")) {
    return '<div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=2005139"></script></div>';
  } else if (hostname.startsWith("m.klaipeda")) {
    if (index == 0) {
      return '<!-- Tag for klaipeda.diena.lt - KL M8 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=648483"></script></div>';
    } else if (index == 1) {
      return '<!-- Tag for klaipeda.diena.lt - KL M9 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847328"></script></div>';
    } else if (index == 2) {
      return '<!-- Tag for klaipeda.diena.lt - KL M10 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847329"></script></div>';
    }
  } else if (hostname.startsWith("kauno.diena")) {
    return '<div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=2027604"></script></div>';
  } else if (hostname.startsWith("m.kauno.diena")) {
    if (index == 0) {
      return '<!-- Tag for kauno.diena.lt - KD M8 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=648426"></script></div>';
    } else if (index == 1) {
      return '<!-- Tag for kauno.diena.lt - KD M9 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847324"></script></div>';
    } else if (index == 2) {
      return '<!-- Tag for kauno.diena.lt - KD M10 placement --><div class="d-block w-100 text-align-center my-4"><script data-adfscript="adx.adform.net/adx/?mid=847325"></script></div>';
    }
  } else {
    return "";
  }
};
